import { FunctionComponent, useEffect, useState } from "react";
// import moment from "moment";
import AdminServices from "services/admin-services";
import Loader from "common/Loader";
import { handlingUrlParams } from "Utils/AppUtils";
import JobTable from "./JobTable";
import DocTable from "./DocTable";
import { Button } from "primereact/button";
import moment from "moment";

interface ViewJobProps {
  onClose: () => void;
  onSubmitSuccess: () => void;
  customerId: number;
  jobData: any;
}

interface InfoRowProps {
  label: string;
  value: string | number | boolean | null | undefined;
}

const InfoRow: FunctionComponent<InfoRowProps> = ({ label, value }) => {
  return (
    <div className="border border-gray-200 rounded-md p-3 shadow-sm bg-gray-50">
      <div className="text-gray-500 text-xs uppercase font-medium mb-1">
        {label}
      </div>
      <div className="text-gray-800 font-semibold text-sm">
        {value !== null && value !== undefined && value !== ""
          ? value.toString()
          : "NA"}
      </div>
    </div>
  );
};

const ViewJob: FunctionComponent<ViewJobProps> = ({
  jobData,
  customerId,
  onClose,
}) => {
  const [showJobTable, setShowJobTable] = useState<boolean>(false);
  const [showDocTable, setShowDocTable] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  if (!jobData) {
    return <div className="p-4 text-gray-500">No job selected</div>;
  }

  const formatDate = (date: string) => {
    if (!date) return "NA";
    return moment(date).isValid()
      ? moment(date).format("MM/DD/YYYY hh:mm A")
      : "Invalid Date";
  };

  useEffect(() => {
    setShowJobTable(true); // Show JobTable immediately, it will fetch its own data
    setShowDocTable(true); // Show DocTable immediately, it will fetch its own data
  }, []);

  const confirmJob = () => {
    setLoading(true);
    AdminServices.confirmJob(
      jobData?.id,
      handlingUrlParams({
        customerId: customerId,
      })
    )
      .then((response: any) => {
        if (response) {
          onClose();
        }
      })
      .catch((e: Error) => {
        console.log(e);
        setLoading(false);
      });
  };

  return (
    <>
      <div className="p-3">
        {/* Header with Back Button */}
        <div className="flex flex-col mb-6">
          <div className="flex items-center gap-3">
            <Button
              label="Back"
              icon="pi pi-arrow-left"
              className="p-button-text p-button-sm"
              onClick={onClose}
            />
          </div>
        </div>

        {/* Two-Column Grid */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-sm">
          {/* <InfoRow label="Job ID" value={jobData.id} /> */}
          {/* <InfoRow label="Customer ID" value={jobData.customerId} /> */}
          <InfoRow
            label="Job ID - Name"
            value={`${jobData.id} - ${jobData.name}`}
          />
          <InfoRow label="Description" value={jobData.description} />
          <InfoRow label="Package Name" value={jobData.packageName} />
          <InfoRow label="Merge Option" value={jobData.mergeOption?.name} />
          {/* <InfoRow label="Status ID" value={jobData.status?.name} /> */}
          {/* <InfoRow label="Active" value={jobData.isActive ? "Yes" : "No"} /> */}
          <InfoRow label="Created By" value={jobData.createdBy} />
          <InfoRow
            label="Created Date"
            value={formatDate(jobData.createdDate)}
          />
          {/* <InfoRow label="Start Date" value={formatDate(jobData.startDate)} /> */}
          {/* <InfoRow label="End Date" value={formatDate(jobData.endDate)} /> */}
        </div>

        {showJobTable && (
          <div className="py-5">
            <JobTable
              customerId={customerId}
              jobId={jobData.id}
              statusID={jobData.statusId}
            />
          </div>
        )}

        {showDocTable && (
          <div className="py-5">
            <DocTable
              customerId={customerId}
              jobId={jobData.id}
              statusID={jobData.statusId}
            />
          </div>
        )}
      </div>
      {jobData.statusId === 18 && (
        <div className="bg-slate-100 p-3 flex flex-row justify-between">
          <div></div>
          <div className="flex flex-row">
            <Button
              label="Cancel"
              icon="pi pi-times"
              onClick={onClose}
              className="p-button-sm p-button-danger p-button-outlined mx-4"
            />
            <div className="mx-2"></div>
            <Button
              label="Confirm"
              type="submit"
              icon="pi pi-check"
              className="p-button-sm p-button-success p-button-outlined"
              onClick={() => confirmJob()}
            />
          </div>
        </div>
      )}
      {loading && <Loader />}
    </>
  );
};

export default ViewJob;
